import React from 'react'
import ChatSetting from '../../components/Chat/ChatSetting'

function ChatSettingPage() {
  return (
    <ChatSetting/>
  )
}

export default ChatSettingPage